interface ColumnDragGhostProps {
    label: string
    width: number
}

export const ColumnDragGhost = ({ label, width }: ColumnDragGhostProps) => (
    <div
        className="-rotate-[1.8deg] overflow-hidden bg-surface shadow-overlay backdrop-blur-[2px]"
        style={{ width: `${width}px`, minHeight: '240px', maxHeight: 'min(66vh, 520px)' }}
    >
        <div className="flex h-[30px] items-center border-b border-border bg-surface px-2">
            <span className="truncate text-[13px] font-medium leading-[1.35] text-foreground-muted">{label}</span>
        </div>
        <div className="flex flex-col gap-[3px] px-1.5 py-1">
            {Array.from({ length: 9 }).map((_, rowIndex) => (
                <div key={`ghost-row-${rowIndex}`} className="h-11 bg-default" />
            ))}
        </div>
    </div>
)
